import React, { useState, useEffect, useRef } from "react";
import HamburgerMenu from "./hamburger"; // Import HamburgerMenu component
import "../styles/Header.css";

const store = [
  {
    logo: "https://via.placeholder.com/150x150/FFF/cc0f99?text=MdMall", // Placeholder image URL
    logoName: "MdMall", // Store name text
  },
];

const TopBar = () => {
  const [isOpen, setIsOpen] = useState(false); // Manage the menu state here

  // References to the icon and the menu
  const menuRef = useRef(null);
  const iconRef = useRef(null);

  // Function to toggle the menu state
  const toggleMenu = () => {
    setIsOpen(!isOpen);
    //console.log('Menu isOpen state:', !isOpen); // Log the state change
  };
  // WhatsApp number (Replace with your number)
  const whatsappNumber = "+919634517467"; // Add your WhatsApp number here
  // Function to open WhatsApp
  const openWhatsApp = () => {
    // This will work on both desktop and mobile devices
    const message = "Hello, I need assistance!"; // Optional message to pre-fill
    const whatsappLink = `https://wa.me/${whatsappNumber}?text=${encodeURIComponent(
      message
    )}`;
    window.open(whatsappLink, "_blank");
  };
 
   
  return (
    <div className="bg-css">
      <div className="p-0">
        {store.map((item, index) => (
          <div className="logo p-0" key={index}>
            <div className="home-logo">
              <img src={item.logo} alt="Store Logo" />
              <p className="skeleton-text">{item.logoName}</p>
            </div>
            <div className="icon-logo">
              <i
                className="pi pi-whatsapp b"
                aria-hidden="true"
                onClick={openWhatsApp}
              ></i>
              <i
                className="pi pi-user b mr-1 ml-1"
                aria-hidden="true"
                onClick={toggleMenu} // Directly toggle the menu on icon click
                style={{ cursor: "pointer" }}
              ></i>
            </div>
          </div>
        ))}
      </div>
      {/* Pass isOpen directly to HamburgerMenu */}
      <HamburgerMenu isOpen={isOpen} />
    </div>
  );
};

export default TopBar;
